import { Box, Flex, SimpleGrid } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import Card from "../../components/Card";
import GraficoServicosAcolhimento from "../../components/GraficoServicosAcolhimento/index";
import GraficoCriancasAdolescentes from "../../components/GraficoCriancasAdolescentes/index";
import GraficoGenero from "../../components/GraficoGenero/index";
import GraficoFaixaEtaria from "../../components/GraficoFaixaEtaria/index";
import Group from "../../pages/ServicosAcolhimento/Visualizar/Group";
import iconServico from "../../../assets/images/banco.svg";
import iconCrianca from "../../../assets/images/peoples.svg";
import iconPendenciaCrianca from "../../../assets/images/pendCrianca.svg";
import iconPendenciaServico from "../../../assets/images/pendServico.svg";
import iconAviso from "../../../assets/images/aviso.svg";
import DashboardService from "../../../main/services/DashboardService";
import { useAuthProvider } from "../../../Context/AuthProvider";
import { criancaFunc, dashboardFunc } from "../../../helpers/Funcionalidades";
import { useHistory } from "react-router";
import { useAuth } from "react-oidc-context";

const Page = () => {
  const [totalServico, setTotalServico] = useState(0);
  const [totalCrianca, setTotalCrianca] = useState(0);
  const [totalCriancaPendencia, setTotalCriancaPendencia] = useState(0);
  const [totalServicoPendencia, setTotalServicoPendencia] = useState(0);
  const [totalAvisos, setTotalAvisos] = useState(0);

  const [graficoServico, setGraficoServico] = useState([]);
  const [graficoAcolhidoGenero, setGraficoAcolhidoGenero] = useState([]);
  const [graficoAcolhidoFaixa, setGraficoAcolhidoFaixa] = useState([]);
  const [graficoCriancaTipo, setGraficoCriancaTipo] = useState([]);
  const [graficoCriancaTipoMensal, setGraficoCriancaTipoMensal] = useState([]);

  const [loadingTotalServico, setLoadingTotalServico] = useState(false);
  const [loadingTotalCrianca, setLoadingTotalCrianca] = useState(false);
  const [loadingTotalCriancaPendencia, setLoadingTotalCriancaPendencia] =
    useState(false);
  const [loadingTotalServicoPendencia, setLoadingTotalServicoPendencia] =
    useState(false);
  const [loadingTotalAvisos, setLoadingTotalAvisos] = useState(false);

  const [loadingGraficoServico, setLoadingGraficoServico] = useState(false);
  const [loadingGraficoCrianca, setLoadingGraficoCrianca] = useState(false);
  const [loadingGraficoGenero, setLoadingGraficoGenero] = useState(false);
  const [loadingGraficoFaixa, setLoadingGraficoFaixa] = useState(false);

  const { roleKeycloack, user, selectedProfile, selectedOrgao } = useAuthProvider();
  const history = useHistory();
  const auth = useAuth();

  useEffect(() => {
    const token = auth?.user?.access_token;
    if (!token || !user?.sub) return;

    let ignore = false;

    setLoadingTotalServico(true);
    setLoadingTotalCrianca(true);
    setLoadingTotalCriancaPendencia(true);
    setLoadingTotalServicoPendencia(true);
    setLoadingTotalAvisos(true);
    setLoadingGraficoServico(true);
    setLoadingGraficoCrianca(true);
    setLoadingGraficoGenero(true);
    setLoadingGraficoFaixa(true);

    DashboardService.getTotalServico(token)
      .then((res) => {
        if (!ignore) setTotalServico(res.data);
      })
      .finally(() => !ignore && setLoadingTotalServico(false));

    DashboardService.getTotalCrianca(token)
      .then((res) => {
        if (!ignore) setTotalCrianca(res.data);
      })
      .finally(() => !ignore && setLoadingTotalCrianca(false));

    DashboardService.getTotalCriancaPendencia(token)
      .then((res) => {
        if (!ignore) setTotalCriancaPendencia(res.data);
      })
      .finally(() => !ignore && setLoadingTotalCriancaPendencia(false));

    DashboardService.getTotalServicoPendencia(token)
      .then((res) => {
        if (!ignore) setTotalServicoPendencia(res.data);
      })
      .finally(() => !ignore && setLoadingTotalServicoPendencia(false));

    DashboardService.getTotalAvisos(token)
      .then((res) => {
        if (!ignore) setTotalAvisos(res.data);
      })
      .finally(() => !ignore && setLoadingTotalAvisos(false));

    DashboardService.getGraficoServico(token)
      .then((res) => {
        if (!ignore) setGraficoServico(res.data || []);
      })
      .finally(() => !ignore && setLoadingGraficoServico(false));

    Promise.all([
      DashboardService.getGraficoCriancaTipo(token),
      DashboardService.getGraficoCriancaTipoMensal(token),
    ])
      .then(([resTipo, resTipoMensal]) => {
        if (!ignore) {
          setGraficoCriancaTipo(resTipo.data || []);
          setGraficoCriancaTipoMensal(resTipoMensal.data || []);
        }
      })
      .finally(() => !ignore && setLoadingGraficoCrianca(false));

    DashboardService.getGraficoAcolhidoGenero(token)
      .then((res) => {
        if (!ignore) setGraficoAcolhidoGenero(res.data || []);
      })
      .finally(() => !ignore && setLoadingGraficoGenero(false));

    DashboardService.getGraficoAcolhidoFaixa(token)
      .then((res) => {
        if (!ignore) setGraficoAcolhidoFaixa(res.data || []);
      })
      .finally(() => !ignore && setLoadingGraficoFaixa(false));

    return () => {
      ignore = true;
    };
  }, [auth?.user?.access_token, user?.sub, selectedProfile, selectedOrgao]);

  return (
    <Flex
      px={["5px", "30px"]}
      h="100%"
      flexDir="column"
      w="100%"
      maxW="2000px"
      overflow="auto"
      pb={["10px", "20px"]}
    >
      <Group mt={1} title={"Dashboard"} voltar={true} mtDivider={"2px"}>
        <>
          <Box mt={2}>
            <SimpleGrid
              columns={{
                base: 1,
                sm: 2,
                md: 3,
                lg: 4,
                xl: roleKeycloack?.includes(
                  dashboardFunc.dashboardAvisosVisualizar
                )
                  ? 5
                  : 4,
              }}
              spacing={{ base: 3, lg: 6 }}
            >
              <Flex
                onClick={() => {
                  history.push("/dashboard/servico-acolhimento");
                }}
                h={"80%"}
              >
                <Card
                  title={"Serviço(s) de Acolhimento"}
                  total={`${totalServico}`}
                  icon={iconServico}
                  loading={loadingTotalServico}
                />
              </Flex>

              <Flex
                onClick={() => {
                  history.push("/dashboard/crianca");
                }}
                h={"80%"}
              >
                <Card
                  title={"Crianças e Adolescentes"}
                  total={`${totalCrianca}`}
                  icon={iconCrianca}
                  loading={loadingTotalCrianca}
                />
              </Flex>

              {roleKeycloack?.includes(
                dashboardFunc.dashboardPendenciasVisualizar
              ) && (
                <Flex
                  onClick={() => {
                    history.push("/dashboard/crianca-pendencias");
                  }}
                  h={"80%"}
                >
                  <Card
                    title={"Pendências Crianças e Adolescentes"}
                    total={`${totalCriancaPendencia}`}
                    icon={iconPendenciaCrianca}
                    loading={loadingTotalCriancaPendencia}
                  />
                </Flex>
              )}

              {roleKeycloack?.includes(
                dashboardFunc.dashboardPendenciasVisualizar
              ) && (
                <Flex
                  onClick={() => {
                    history.push("/dashboard/servico-acolhimento-pendencias");
                  }}
                  h={"80%"}
                >
                  <Card
                    title={"Pendências Serviço(s) de Acolhimento"}
                    total={`${totalServicoPendencia}`}
                    icon={iconPendenciaServico}
                    loading={loadingTotalServicoPendencia}
                  />
                </Flex>
              )}

              {roleKeycloack?.includes(
                dashboardFunc.dashboardAvisosVisualizar
              ) && (
                <Flex
                  onClick={() => {
                    history.push("/dashboard/avisos");
                  }}
                  h={"80%"}
                >
                  <Card
                    title={"Avisos"}
                    total={`${totalAvisos}`}
                    icon={iconAviso}
                    loading={loadingTotalAvisos}
                  />
                </Flex>
              )}
            </SimpleGrid>
          </Box>

          <Box>
            <SimpleGrid
              columns={{
                base: 1,
                lg: roleKeycloack?.includes(
                  criancaFunc.visualizarTudoAcolhimento
                )
                  ? 1
                  : 2,
              }}
              spacing={6}
            >
              {!roleKeycloack?.includes(
                criancaFunc.visualizarTudoAcolhimento
              ) && (
                <GraficoServicosAcolhimento
                  dados={graficoServico}
                  loadingGraficoServico={loadingGraficoServico}
                />
              )}
              <GraficoCriancasAdolescentes
                dados={graficoCriancaTipo}
                dadosGrafico={graficoCriancaTipoMensal}
                loadingGraficoCrianca={loadingGraficoCrianca}
              />
            </SimpleGrid>

            <SimpleGrid mt={6} columns={{ base: 1, lg: 2 }} spacing={6}>
              <GraficoGenero
                dados={graficoAcolhidoGenero}
                loadingGraficoGenero={loadingGraficoGenero}
              />
              <GraficoFaixaEtaria
                dados={graficoAcolhidoFaixa}
                loadingGraficoFaixa={loadingGraficoFaixa}
              />
            </SimpleGrid>
          </Box>
        </>

        {/* <Flex pt="20px">
          <ChartBox width="auto" height="auto" />
        </Flex> */}
      </Group>
      {/* <Box>
                <tableau-viz id="tableauViz"
                    src="https://public.tableau.com/views/Dashboard-Robo/Alertas?:language=pt-BR&publish=yes&:sid=&:redirect=auth&:display_count=n&:origin=viz_share_link"
                >
                </tableau-viz>
            </Box> */}
    </Flex>
  );
};
export default Page;
